<template>
  <!-- 保险信息 模块  订单填写 订单详情中-->
  <div class="approval">
    <van-cell-group v-show="isssbz && sentRemark">
      <van-field label="送审备注" :value="sentRemark" readonly />
    </van-cell-group>
    <van-cell
      @click="toggle"
      title="审批详情"
      is-link
      value-align="left"
      class="cell"
    >
      {{ spDetail.gzmc }}
    </van-cell>

    <van-popup
      v-model="isShow"
      class="popup-width" 
      :get-container="getContainer"
      :style="{ maxHeight: '60%' }"
    >
      <div class="planeBox">
        <approval-progress
          v-if="progress"
          :order-id="orderId"
          :ordertype="orderType"
        />
        <approval-rule
          v-if="rule"
          :spgz-id="spgzId"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Cell, Field, CellGroup} from 'vant'

import approvalProgress from './approvalProgress'  //审批进度
import approvalRule from './approvalRule' //审批规则 
    
export default {
  name: 'Approval',
  components: {
    approvalRule,
    approvalProgress,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
  props:{
    vipStatus:{
      type: [String, Number],
      default: 0
    },
    spgzId: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    orderType: {
      type: String,
      default: ''
    },
    element:{
      type: String,
      default: ''
    },
    isssbz: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isShow: false,
      progress: false,
      rule: false,
      spDetail: {},
      sentRemark:''
    }
  },
  created () {
    if (this.vipStatus == 0) {//审批规则
      this.rule = true
    } else {//审批进度
      this.progress = true
    }
    this.getSpgzInfo()
    this.getSentRemark()
  },
  methods: {
    getSentRemark () {
      if(this.progress){
        this.$api['approval/vipOrderAppProgress']({
          'orderId': this.orderId,
          'orderType': this.orderType 
        }).then(res => {
          this.sentRemark =  res.data.sentRemark
        })
      }
    },
    toggle () {
      if(this.progress){
        this.$api['approval/vipOrderAppProgress']({
          'orderId': this.orderId,
          'orderType': this.orderType 
        }).then(res => {
          let cache=res.data
          if (cache) {
            this.isShow = true
          } else {
            this.$dialog.alert({ message: '没有审批进度数据！'})
          }
        })
      }else{
        this.isShow = true
      }
    },
    getSpgzInfo () {
      if(!this.spgzId) return
      this.$api['approval/vipSpgzGetInfo']({spgzId: this.spgzId}).then(res => {
        let cache = res.data || {}
        this.spDetail = cache
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
  }
}
</script>

<style scoped lang="less">
.approval {
  .planeBox{
      height: auto;
  }
}
</style>
